export class Material {
    id = null;
    materialNumber = '';
    description = '';
}


